export default "__VITE_ASSET__CrXAopuc__";